import React, { Fragment } from 'react';
import { Tooltip } from '@material-ui/core';
import { toAbsoluteUrl } from 'src/_metronic/_helpers';

export const IconButton = ({
	id,
	onClick = () => {},
	color = 'warning',
	label = '',
	disabled,
	style = {},
	tooltip = false,
	src,
	className = '',
	tooltipPos = 'top',
	data = {},
}) => {
	const buttonStyle = {
		cursor: disabled ? 'not-allowed' : 'pointer',
		...style,
	};

	return (
		<Fragment>
			{!tooltip ? (
				<button
					id={id}
					className={`btn btn-icon btn-${color} btn-sm ${className}`}
					onClick={() => onClick()}
					disabled={disabled}
					style={buttonStyle}
				>
					<span className="svg-icon svg-icon-md">
						<img src={toAbsoluteUrl(src)} alt="icono" width={500} />
						<p style={{ marginBottom: -5 }}>{label}</p>
					</span>
				</button>
			) : (
				<Tooltip title={label} placement={tooltipPos}>
					<button
						id={id}
						className={`btn btn-icon btn-${color} btn-sm ${className}`}
						onClick={() => onClick(data)}
						disabled={disabled}
						style={buttonStyle}
					>
						<span className="svg-icon svg-icon-md">
							<img src={toAbsoluteUrl(src)} alt="icono" width={500} />
						</span>
					</button>
				</Tooltip>
			)}
		</Fragment>
	);
};
